module.exports = __webpack_public_path__ + "static/media/29FUNOV14.6a896dc6.jpg";